export enum Endpoints {
  Login = "/officers/login-with-token",
  LoginWithEmailPassword = "/officers/login-with-email",
  LogOut = "/officers/users/logout",
  Me = "/officers/users/me",
  KhabeerErrorReports = "/officers/error-reports",
  KhabeerErrorReportSimulate = "/officers/error-reports/simulate/{type}",
  UsersList = "/officers/users",
  UsersCreate = "/officers/users",
  RolessList = "/officers/roles",
  RolesCreate = "/officers/roles",
  RolesDelete = "/khabeer/roles",
  MerchantList = "/khabeer/merchants",
  MerchantListByUUid = "/khabeer/merchants/uuid",
  MerchantModerators = "/officers/stores/{id}/users",
  MerchantsApps = "/officers/merchant/apps",
  StoreInfo = "/officers/stores",
  CustomThemes = "/khabeer/store/{id}/custom-themes",
  StorePackage = "/officers/accounts/subscriptions",
  merchantNotes = "/officers/store/note",
  PersmissionsList = "/officers/permissions",
  PermissionsAttach = "/permissions",
  ImpersonationsList = "/officers/user-impersonations",
  CreateImpersonationRequest = "/officers/user-impersonations",
  CancelImpersonationRequest = "/officers/user-impersonations/{requestId}/cancel",
  StoreCategories = "/officers/store-categories",
  StoreCategoryUpdate = "/officers/stores/{id}/category",
  MerchantUpdate = "/officers/merchant/{merchantId}/info",
  OrderStatusUpdate = "/officers/orders/{order-id}/change-order-status",
  MerchantPurchases = "/officers/purchases",
  MerchantPurchasesV2 = "/officers/pv2/purchases",
  PurchaseV2Get = "/khabeer/purchases/",
  PurchaseV2Create = "/khabeer/purchases",
  PurchaseV2BankTransferApprove = "/khabeer/purchases/bank-transfer/approve",
  PurchaseV2BankTransferReject = "/khabeer/purchases/bank-transfer/reject",
  PurchaseV2BankTransferRefund = "/khabeer/purchases/bank-transfer/refund",
  PurchaseV2PurchaseItemRefund = "/khabeer/purchases/purchase-item/refund",
  PurchasablesV2Search = "/khabeer/purchases/purchasable-items/search",
  RejectPurchases = "/khabeer/purchases/{purchase_id}/reject",
  ApprovePurchases = "/khabeer/purchases/{purchase_id}/approve",
  InventoryAddresses = "/officers/store/inventory-locations?store_id={store_id}",
  Coupons = "/khabeer/coupons",
  CouponsImport = "/khabeer/coupons/import",
  CouponsV2 = "/khabeer/couponsv2",
  CouponV2Details = "/khabeer/couponsv2/{uuid}",
  CouponV2Offers = "/khabeer/couponsv2/{uuid}/offers",
  CouponV2OfferDetails = "/khabeer/couponsv2/{uuid}/offers/{offerUuid}",
  CountryList = "/officers/countries",
  CurrencyList = "/officers/currencies",
  ListIndustries = "/industries",
  CategoryList = "/discovery/categories?offset={ofset}&limit={limit}",
  CategoryCreate = "/discovery/categories",
  fileUpload = "/uploads",
  Products = "/discovery/products",
  ListMazeedIndustries = "/industries",
  Purchasables = "/officers/purchasables",
  Packages = "/khabeer/core-packages/list",
  PackageDetails = "/khabeer/core-packages/details/{id}",
  MazeedProductDetails = "/discovery/products/{id}",
  StoreProductsLimit = "/discovery/stores/{id}/products-limit",
  StoreApprove = "/discovery/stores/{id}/approve",
  StoreReject = "/discovery/stores/{id}/reject",
  StoreBlock = "/discovery/stores/{id}/block",
  StoreUnblock = "/discovery/stores/{id}/unblock",
  StoreDisable = "/discovery/stores/{id}/disable",
  StoreActivate = "/discovery/stores/{id}/activate",
  ManuallyList = "/discovery/stores/{id}/manually-list-active",
  ManuallyUnList = "/discovery/stores/{id}/manually-list-disabled",
  RejectReasons = "/review-reasons/meta?filters[entities][]={target}&filters[types][]=reject",
  BankInfo = "/khabeer/banks/{id}",
  InvoiceRegeneration = "/khabeer/purchases/{invoiceNumber}/{storeId}",
  CitiesByCountryId = "/settings/cities?countries_id={id}",
  AllCitiesByCountryId = "/settings/cities?country_id={id}",
  Settlements = "/settlements",
  SettlementsReject = "/settlements/reject",
  SettlementsSettle = "/settlements/settle",
  SettlementData = "/settlements/:id",
  SettlementUninvoice = "/settlements/{id}/uninvoice",
  StoreDomains = "/officers/store/domains?store_id={id}",
  StoreDomainCreate = "/officers/store/domains",
  StoreDomainDelete = "/officers/store/domains/{domain_id}/delete",
  StoreDomainAcivate = "/officers/store/domains/{domain_id}/activate",
  StoreDomainForceActivate = "/officers/stores/{store_id}/domains/{domain_id}/set-active",
  StoreDomainVerify = "/officers/store/domains/{domain_id}/verify",
  StoreDomainDetails = "/officers/store/domains/{domain_id}/details?store_id={store_id}",
  StoreWallet = "/officers/wallets",
  StoreWalletUpdate = "/officers/wallets/update-wallet",
  WalletVerificationRequests = "/officers/wallets/list-wallet-verifications",
  WalletVerificationProcess = "/officers/wallets/process-wallet-verification",
  WalletUpdate = "/officers/wallets/update-wallet",
  WalletWithdrawlRequests = "/officers/wallets/list-withdrawals",
  WalletWithdrawProcess = "/officers/wallets/process-withdrawal",
  WalletAllTransactions = "/officers/wallets/list-transactions",
  PackageCreate = "/khabeer/core-packages/register",
  PackageDelete = "/khabeer/core-packages/{id}/delete-package",
  PackageActivate = "/khabeer/core-packages/{id}/activate",
  PackageUpdate = "/khabeer/core-packages/{id}/update-package",
  FetchProducts = "/khabeer/core-packages/features",
  PackageRegisterFeature = "/khabeer/core-packages/{id}/features/change",
  PackageRegisterDelete = "/khabeer/core-packages/{id}/features/delete",
  PackageVariantDelete = "/khabeer/core-packages/{id}/variants/{variantId}/delete",
  PackageVariantAdd = "/khabeer/core-packages/{id}/variants/add",
  SubscriptionProducts = "/khabeer/core-products/list",
  SubscriptionProductDetails = "/khabeer/core-products/details/{id}",
  SubscriptionProductUpdate = "/khabeer/core-products/update/{id}",
  SubscriptionProductRegister = "/khabeer/core-products/register",
  SubscriptionProductDelete = "/khabeer/core-products/delete/{id}",
  SMSGatewaySenders = "/officers/stores/{store_id}/sms-gateway-senders",
  SMSNotificationsBalance = "/officers/stores/{store_id}/order-notifications/balance",
  SMSProviderCurrent = "/khabeer/sms/provider-management/current",
  SMSProviderSwitch = "/khabeer/sms/provider-management/switch",
  SMSProviderBulkSwitch = "/khabeer/sms/provider-management/bulk-switch",
  SMSProviderDisable = "/khabeer/sms/provider-management/disable",
  SMSProviderEnable = "/khabeer/sms/provider-management/enable",
  SMSProviderLogs = "/khabeer/sms/provider-management/logs",
  Themes = "/officers/themes-store",
  BulkChangeOrderStatus = "/officers/orders/bulk-change-order-status",
  SubscriptionProductsAvailableFeatures = "/khabeer/core-products/available-features",
  SMSSenderNames = "/officers/stores/sms-campaigns/senders-names?order_by=created_at&order_direction=desc&page={page}",
  SMSCampignSenderId = "/officers/stores/{store_id}/sms-campaigns-sender-id",
  SMSCampignBalance = "/officers/stores/{store_id}/sms-campaigns/balance",
  CustomerList = "/customers?offset={ofset}&limit={limit}",
  CustomerDetail = "/officers/customers/{id}",
  CustomerAddresses = "/khabeer/customers/{id}/addresses",
  CustomerErasePreview = "/khabeer/customers/erase/preview",
  CustomerErase = "/khabeer/customers/erase",
  SMSSenderNameAction = "/officers/stores/sms-campaigns/senders-names/{sender_id}/{action}",
  storeSettings = "/officers/stores/{storeId}/settings?code=one_signal",
  generatedInvoice = "/resellers/settlements/{settlementId}/invoice",
  refundResellerTransaction = "/resellers/transactions/{transactionId}/refund",
  listResellerTransactionRefunds = "/resellers/transactions/{transactionId}/adjustments",
  Dashboard = "/dashboard",
  AddCity = "/officers/cities",
  UpdateCity = "/officers/cities/{id}",
  DeactivateCity = "/officers/cities/{id}/deactivate",
  AssignProductsToCategories = "/discovery/products/products-categories/bulk",
  ShippingCouriers = "/officers/store/shipping/store-couriers?store_id={store_id}",
  EnableShippingMethod = "/officers/store/shipping-methods/{shippingMethodId}/enable?store_id={store_id}",
  DisableShippingMethod = "/officers/store/shipping-methods/{shippingMethodId}/disable?store_id={store_id}",
  DeleteShippingMethod = "/officers/store/shipping-methods/{shippingMethodId}?store_id={store_id}",
  ShippingMethodTiers = "/officers/store/shipping-methods/{shippingMethodId}/tiers?store_id={store_id}",
  ShippingMethodTiersAvailableCities = "/officers/store/shipping-methods/{shippingMethodId}/tiers/available-cities?store_id={store_id}",
  ShippingMethodTiersAvailableCountries = "/officers/store/shipping-methods/{shippingMethodId}/tiers/available-countries?store_id={store_id}",
  EnableShippingMethodTier = "/officers/store/shipping-methods/{shippingMethodId}/tiers/{tierId}/enable?store_id={store_id}",
  DisableShippingMethodTier = "/officers/store/shipping-methods/{shippingMethodId}/tiers/{tierId}/disable?store_id={store_id}",
  ShippingMethodTierUpdate = "/officers/store/shipping-methods/{shippingMethodId}/tiers/{tireId}/?store_id={store_id}",
  UpdateShippingMethod = "/api/shipping/{storeId}/shipping-methods/save?shipping_option_id={id}",
  CreateShippingMethod = "/api/shipping/{storeId}/shipping-methods/save/{type}",
  ShipmentMethodCities = "/officers/store/shipping-methods/{shippingMethodId}/supported-cities/{type}?store_id={storeId}",
  StorePaymentGateway = "/officers/stores/{storeId}/payment-gateways/{paymentGatewayCode}",
  ApplePaySettings = "/officers/stores/{storeId}/settings?code=apple_pay",
  ApplePaySettingsFiles = "/officers/stores/{storeId}/settings?code=apple_pay",
  WellKnownFiles = "/officers/stores/{storeId}/settings?code=well_known",
  ApplePayDomainAssociation = "payments/apple-pay/{storeId}/domain-association",
  ApplePayCertificate = "payments/apple-pay/{storeId}/certificate",
  ApplePayMerchantUpdate = "/officers/stores/{storeId}/settings",
  GetActivationParameters = "/officers/shipping/activation-parameters/{driverCode}?store_id={storeId}",
  GetInventoryLocations = "/officers/store/inventory-locations?store_id={storeId}",
  GetSupportedCities = "/officers/shipping/couriers/{courierId}/supported-cities/{type}",
  GetMethodDetails = "/officers/store/shipping-methods/{shippingMethodId}?store_id={storeId}",
  GetSupportedCitiesForIntegratedShipping = "/api/shipping/couriers/integrated/{courierId}/supported-cities/{type}/{storeId}",
  LogOutAllUsers = "/khabeer/merchants/{uuid}/logout-all-users",
  ToolsActiveApp = "/khabeer/tools/zam/activate-app",
  DeleteOneSignalAppsForStore = "/khabeer/tools/zam/delete-store-app-settings",
  RebuildPublicWebsite = "/khabeer/tools/zam/rebuild-public-website",
  TriggerExpiredAddons = "/khabeer/tools/zam/trigger-addon-expiry",
  ForgotEmailURL = "/khabeer/tools/zam/forgot-email-url",
  GeneratePartnerPasswordURL = "/khabeer/tools/zam/generate-new-password",
  PreinstallApp = "/khabeer/tools/zam/preinstall-app",
  BulkPreinstallApp = "/khabeer/tools/zam/bulk-preinstall-app",
  ExtendSubscription = "/khabeer/tools/zam/extend-subscription",
  ToolsRevokeTokens = "/khabeer/tools/zam/revoke-tokens",
  ToolsApproveLandingPage = "/officers/landing-pages/templates/{templateId}/approve",
  ToolsTriggerOrderWebhook = "/khabeer/tools/zam/trigger-order-webhook",
  ExtendPackageSubscription = "/khabeer/tools/subscriptions/extend-subscription",
  GetLogs = "/khabeer/action_log",
  RefreshStoreCaches = "/khabeer/tools/zam/refresh-stores-cache",
  MerchantSoftDelete = "/khabeer/merchants/{id}",
  ActivateEnterprisePackage = "/khabeer/merchants/{id}/activate-enterprise-package",
  ActivateProfessionalTrialPackage = "/khabeer/merchants/{id}/activate-professional-trial-package",
  MerchantSalesBlock = "/khabeer/merchants/{id}/block",
  MerchantSalesUnblock = "/khabeer/merchants/{id}/unblock",
  MerchantCfCachePurge = "/khabeer/merchants/{id}/cf-cache/purge",
  RefundPurchase = "/officers/purchases/{id}/refund",
  OrderDetails = "/officers/stores/{storeid}/orders/{orderId}",
  StoreSubscriptionInfo = "/khabeer/merchants/{id}/subscription/get-details",
  UpdateMerchantRelationsInfo = "/khabeer/merchants/{id}/update-merchant-relations",
  AddPurchasesNote = "/khabeer/purchases/{purchase_id}/add-note",
  StoreTags = "/officers/stores/{storeId}/tags",
  ListTags = "/officers/tags",
  AddTagToStore = "/officers/stores/tags/{storeId}",
  RemoveStoreTag = "/officers/stores/{storeId}/tags/{taggableId}",
  StoreCachiers = "/khabeer/purchases/store-cashiers/{storeId}",
  StorePaymentGateways = "/officers/stores/{storeid}/payment-gateways",
  merchantKYC = "/officers/kyc",
  StoreSubscriptionExtension = "/officers/accounts/subscriptions/extend/{id}",
  AvailablePackagesForTargeting = "/khabeer/addons/management-ui-config",
  GrowthInfo = "/khabeer/merchant_growth/{id}",
  GrowthCommunity = "/khabeer/merchant_growth/{id}/whatsapp",
  GrowthCommunityRequests = "/khabeer/merchant_growth/requests",
  StoreCards = "/khabeer/user-cards/store/{id}",
  DeleteStoreCard = "/khabeer/user-cards/user/{user_uuid}/card/{id}",
  getCommissions = "/khabeer/commissions/list",
  setCommission = "/khabeer/commissions",
  StoreSessions = "/officers/user-impersonations/store/{id}",
  GetLoginUrl = "/officers/user-impersonations/{requestId}/request-login-url",
  InviteUsersToSession = "/officers/user-impersonations/{requestId}/invite",
  RemoveUsersFromSession = "/officers/user-impersonations/{requestId}/remove",
  UploadFilesWithText = "/officers/switchers/salla/import-products",
  UploadOrders = "/officers/switchers/zid/import-orders",
  latestFeatures = "/officers/latest-features?is_enabled=1",
  latestFeaturesUpdate = "/officers/latest-features/{id}",
  latestFeaturesDelete = "/officers/latest-features/{id}",
  ContractsList = "/officers/enterprise-contracts/v2",
  ContractsApprove = "/officers/enterprise-contracts/v2/contract/{id}/approve",
  ContractsReject = "/officers/enterprise-contracts/v2/contract/{id}/reject",
  ContractsPurchaseApprove = "/officers/enterprise-contracts/v2/contract/{id}/purchase/approve",
  ContractsPurchaseReject = "/officers/enterprise-contracts/v2/contract/{id}/purchase/reject",
  ContractsPurchaseReceiptUpdate = "/officers/enterprise-contracts/v2/{id}/upload-bank-transfer-receipt",
  GetJobProgress = "/officers/jobs/{id}/progress",
  GetJobStatus = "/officers/jobs/{id}/status",
  StoreServiceFeeToggle = "/khabeer/service-fee/stores/{id}/settings",
  StoreServiceFee = "/khabeer/service-fee/stores/{id}/settings",
  PlatformServiceFees = "/khabeer/service-fee/platform/settings",
  StoreCashiers = "/officers/stores/{storeId}/cashiers",
  StoreCashierTerminal = "/officers/stores/{storeId}/cashiers/{cashierId}/terminal",
  StoreCashierExpiration = "/officers/stores/{storeId}/cashiers/{cashierId}/expiration",
  StoreCashierSessionStatus = "/officers/stores/{storeId}/cashiers/{cashierId}/sessions/{sessionId}/status",
  StorePosPaymentMethods = "/officers/stores/{storeId}/pos-payment-methods",
  StorePosPaymentMethodsAvailable = "/officers/stores/{storeId}/pos-payment-methods/available",
  StorePosPaymentMethodStatus = "/officers/stores/{storeId}/pos-payment-methods/{paymentMethodId}/status",
  StorePosPaymentMethodSplit = "/officers/stores/{storeId}/pos-payment-methods/{paymentMethodId}/split",
  StorePosPaymentMethodDuplication = "/officers/stores/{storeId}/pos-payment-methods/{paymentMethodId}/duplication",
  StorePosPaymentMethodDefault = "/officers/stores/{storeId}/pos-payment-methods/{paymentMethodId}/default",
  StorePosPaymentMethodName = "/officers/stores/{storeId}/pos-payment-methods/{paymentMethodId}/name",
  StoreMarketplaces = "/officers/store/marketplace-connect/store-marketplaces",
  TrendyolCredentials = "/officers/store/marketplace-connect/store-marketplaces/{id}/trendyol-credentials",
  UploadReviews = "/khabeer/merchants/product-reviews/import",
  PaymentLinks = "/officers/pv2/payment-links",
  PaymentLinkDetails = "/officers/pv2/payment-links/{id}",
  CurrencyExchange = "/officers/pv2/currency-exchange",
  PaymentLinksConnectWithStore = "/officers/pv2/payment-links/connect-with-store",
  PaymentLinksCancel = "/officers/pv2/payment-links/cancel",
  UploadCoupons = "/khabeer/merchants/coupons/import",
  DnsRecords = "/officers/dns/{domain}/records",
  DnsZones = "/officers/dns/{domain}/zones",
  DnsRecordUpdate = "/officers/dns/{domain}/records/{record}",
  OneTimeOffers = "/officers/one-time-offers",
  NationalDayOffer = "/officers/store/nd2026",
  StartSwitchersCampaign = "/officers/store/nd2026/{id}/convert-to-switcher",
}
